import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Directive, ViewContainerRef, ViewChild, Component, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i1 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i2 from '@ngx-translate/core';
import * as i3 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
const _c0 = ["placeholder"];
let AbstractWidgetDirective = /*#__PURE__*/(() => {
  class AbstractWidgetDirective {
    constructor() {
      this.settingsChanged = new EventEmitter();
      this.settingsValidChanged = new EventEmitter();
      this.loading = new EventEmitter();
      this.settingsNeeded = new EventEmitter();
      this.customEvent = new EventEmitter();
    }
    ngOnDestroy() {
      this.destroy();
    }
    destroy() {
      this.unsubscribeSubscriptions();
    }
    subscribeToDataChanges(observer) {
      if (this.definition.dataChangedSubject) {
        this.dataChangedSubscription = this.definition.dataChangedSubject.subscribe(observer);
      }
    }
    notifyLoading(loading) {
      this.loading.emit(loading);
    }
    unsubscribeSubscriptions() {
      if (this.dataChangedSubscription) {
        this.dataChangedSubscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function AbstractWidgetDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractWidgetDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AbstractWidgetDirective,
        inputs: {
          definition: "definition",
          configMode: "configMode"
        },
        outputs: {
          settingsChanged: "settingsChanged",
          settingsValidChanged: "settingsValidChanged",
          loading: "loading",
          settingsNeeded: "settingsNeeded",
          customEvent: "customEvent"
        }
      });
    }
  }
  return AbstractWidgetDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaWidgetPlaceholderComponent = /*#__PURE__*/(() => {
  class AzavistaWidgetPlaceholderComponent {
    constructor(componentFactoryResolver) {
      this.componentFactoryResolver = componentFactoryResolver;
      this.settingsChanged = new EventEmitter();
      this.settingsValid = new EventEmitter();
      this.loading = new EventEmitter();
      this.settingsNeeded = new EventEmitter();
      this.customEvent = new EventEmitter();
      this.destroyed$ = new Subject();
    }
    ngOnInit() {
      const cmpFactory = this.componentFactoryResolver.resolveComponentFactory(this.definition.componentType);
      const cmpRef = this.viewChild.createComponent(cmpFactory);
      cmpRef.instance.definition = this.definition;
      cmpRef.instance.configMode = this.configMode;
      cmpRef.instance.settingsChanged.pipe(takeUntil(this.destroyed$)).subscribe({
        next: data => this.processSettingsChanged(data)
      });
      cmpRef.instance.settingsValidChanged.pipe(takeUntil(this.destroyed$)).subscribe({
        next: valid => this.processSettingsValid(valid)
      });
      cmpRef.instance.loading.pipe(takeUntil(this.destroyed$)).subscribe({
        next: loading => this.processLoading(loading)
      });
      cmpRef.instance.settingsNeeded.pipe(takeUntil(this.destroyed$)).subscribe({
        next: () => this.processSettingsNeeded()
      });
      cmpRef.instance.customEvent.pipe(takeUntil(this.destroyed$)).subscribe({
        next: args => this.processCustomEvent(args)
      });
    }
    ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
    }
    processCustomEvent(args) {
      this.customEvent.next(args);
    }
    processSettingsValid(valid) {
      this.settingsValid.next(valid);
    }
    processLoading(loading) {
      this.loading.next(loading);
    }
    processSettingsChanged(data) {
      this.settingsChanged.next(data);
    }
    processSettingsNeeded() {
      this.settingsNeeded.next();
    }
    static {
      this.ɵfac = function AzavistaWidgetPlaceholderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWidgetPlaceholderComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaWidgetPlaceholderComponent,
        selectors: [["azavista-widget-placeholder"]],
        viewQuery: function AzavistaWidgetPlaceholderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewChild = _t.first);
          }
        },
        inputs: {
          definition: "definition",
          configMode: "configMode"
        },
        outputs: {
          settingsChanged: "settingsChanged",
          settingsValid: "settingsValid",
          loading: "loading",
          settingsNeeded: "settingsNeeded",
          customEvent: "customEvent"
        },
        standalone: false,
        decls: 2,
        vars: 0,
        consts: [["placeholder", ""]],
        template: function AzavistaWidgetPlaceholderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", null, 0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return AzavistaWidgetPlaceholderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaWidgetDialogComponent = /*#__PURE__*/(() => {
  class AzavistaWidgetDialogComponent {
    constructor(data, sharedSvc) {
      this.data = data;
      this.sharedSvc = sharedSvc;
      this.settingsAreValid = false;
      this.widgetDefinitionForEdit = {
        title: this.data.widgetDefinition.title,
        settings: this.sharedSvc.clone(this.data.widgetDefinition.settings)
      };
      this.definitionForWidgetPlaceholder = {
        ...this.data.widgetDefinition,
        ...this.widgetDefinitionForEdit
      };
    }
    close() {
      this.data.actionSubject.next({
        action: 'close',
        data: this.data
      });
    }
    save() {
      this.data.actionSubject.next({
        action: 'save',
        data: {
          ...this.data,
          widgetDefinition: {
            ...this.data.widgetDefinition,
            ...this.widgetDefinitionForEdit
          }
        }
      });
    }
    onTitleChanged(newTitle) {
      this.safeChange(() => {
        this.widgetDefinitionForEdit.title = newTitle;
        this.settingsAreValid = !!newTitle;
      });
    }
    onSettingsChanged(data) {
      this.safeChange(() => {
        this.settingsAreValid = data.settingsAreValid;
      });
    }
    onSettingsValidChanged(valid) {
      this.safeChange(() => {
        this.settingsAreValid = valid;
      });
    }
    safeChange(fn) {
      window.setTimeout(() => fn());
    }
    static {
      this.ɵfac = function AzavistaWidgetDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWidgetDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaWidgetDialogComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 16,
        vars: 4,
        consts: [[1, "aza-cmp-flex-column", "aza-cmp-padding"], [1, "widget-title-container"], [1, "title", "aza-cmp-full-width"], ["translate", ""], ["matInput", "", 3, "input", "value"], [1, "widget-container"], [3, "settingsChanged", "settingsValidChanged", "definition", "configMode"], ["mat-dialog-actions", "", 1, "dialog-actions", "aza-cmp-dialog-actions"], [1, "aza-cmp-dialog-action-cancel-button", 3, "click"], ["color", "primary", 1, "aza-cmp-dialog-action-apply-button", 3, "click", "disabled"]],
        template: function AzavistaWidgetDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "mat-form-field", 2)(3, "mat-label")(4, "span", 3);
            i0.ɵɵtext(5, "WIDGET_TITLE");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "input", 4);
            i0.ɵɵlistener("input", function AzavistaWidgetDialogComponent_Template_input_input_6_listener($event) {
              return ctx.onTitleChanged($event.target.value);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "div", 5)(8, "azavista-widget-placeholder", 6);
            i0.ɵɵlistener("settingsChanged", function AzavistaWidgetDialogComponent_Template_azavista_widget_placeholder_settingsChanged_8_listener($event) {
              return ctx.onSettingsChanged($event);
            })("settingsValidChanged", function AzavistaWidgetDialogComponent_Template_azavista_widget_placeholder_settingsValidChanged_8_listener($event) {
              return ctx.onSettingsValidChanged($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 7)(10, "azavista-button", 8);
            i0.ɵɵlistener("click", function AzavistaWidgetDialogComponent_Template_azavista_button_click_10_listener() {
              return ctx.close();
            });
            i0.ɵɵelementStart(11, "span", 3);
            i0.ɵɵtext(12, "CLOSE");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "azavista-button", 9);
            i0.ɵɵlistener("click", function AzavistaWidgetDialogComponent_Template_azavista_button_click_13_listener() {
              return ctx.save();
            });
            i0.ɵɵelementStart(14, "span", 3);
            i0.ɵɵtext(15, "SAVE");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("value", ctx.widgetDefinitionForEdit.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("definition", ctx.definitionForWidgetPlaceholder)("configMode", true);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", !ctx.settingsAreValid);
          }
        },
        dependencies: [i2.TranslateDirective, i3.AzavistaButtonComponent, i4.MatFormField, i4.MatLabel, i5.MatInput, AzavistaWidgetPlaceholderComponent],
        encapsulation: 2
      });
    }
  }
  return AzavistaWidgetDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaWidgetsModule = /*#__PURE__*/(() => {
  class AzavistaWidgetsModule {
    static {
      this.ɵfac = function AzavistaWidgetsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWidgetsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaWidgetsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, AzavistaSharedModule, AzavistaButtonModule, MatFormFieldModule, MatInputModule]
      });
    }
  }
  return AzavistaWidgetsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractWidgetDirective, AzavistaWidgetDialogComponent, AzavistaWidgetPlaceholderComponent, AzavistaWidgetsModule };
